import { Component, OnInit, ViewChild } from '@angular/core';
import { PlatformLocation } from '@angular/common';

import { ApiService } from './api.service';
import { ControlComponent } from './control/control.component';
import { EditComponent } from './edit/edit.component';
import { ViewComponent } from './view/view.component';

import { Font } from './font';
import { Color } from './color';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  standalone: false
})
export class AppComponent {
  @ViewChild('control') control: ControlComponent;
  @ViewChild('edit') edit: EditComponent;
  @ViewChild('view') view: ViewComponent;

  constructor(
    private api: ApiService,
    private location: PlatformLocation
  ) {
  }

  ngOnInit(): void {
    this.api.getFonts().subscribe(fonts => {
      this.control.fontOptions = fonts;
    });

    this.api.getJFonts().subscribe(jfonts => {
      this.control.jfontOptions = jfonts;
    });

    this.location.onPopState(() => {
	this.onPopState();
    });
  }

  updateParams(): void {
    const param = this.parseQuery(window.location.hash);

    const resolution = param['r'];
    if (resolution) {
      this.control.resolution = Number(resolution);
    }

    if (param['f']) {
      this.control.font = param['f'];
    }

    if (param['j']) {
      this.control.jfont = param['j'];
    }

    if (param['b']) {
      this.control.bold = this.s2b(param['b']);
    }

    if (param['o']) {
      this.control.opaque = this.s2b(param['o']);
    }

    if (param['t']) {
      this.edit.source = decodeURIComponent(param['t']);
    } else {
      this.api.getSample().subscribe(tex => {
        this.edit.source = tex;
      });
    }
  }
  
  ngAfterViewInit(): void {
    this.updateParams();
    
    if (this.edit.platform == 'mac') {
      this.view.keyModifier = 'Cmd';
    } else if (this.edit.platform == 'win') {
      this.view.keyModifier = 'Ctrl';      
    }
  }

  onColorSelected(color: Color): void {
    this.edit.setColor(color);
  }

  onGenerateClicked(): void {
    const tex = this.edit.source;
    const resolution = this.control.resolution;
    const font = this.control.font;
    const jfont = this.control.jfont;
    const bold = this.control.bold;
    const opaque = this.control.opaque;
    const query = this.api.getQuery(tex, resolution, font, jfont, bold, opaque);
    location.hash = query;
    this.view.image = this.api.url + "c=png&" + query;
  }

  onGeneratePressed(): void {
    this.onGenerateClicked();
  }

  onPopState(): void {
    this.updateParams();
  }

  onDownloadClicked(fileType: string) {
    const tex = this.edit.source;
    const resolution = this.control.resolution;
    const font = this.control.font;
    const jfont = this.control.jfont;
    const bold = this.control.bold;
    const opaque = this.control.opaque;
    const data = this.api.getImage(tex, resolution, font, jfont, bold, opaque, fileType).subscribe(data => {
      const url = URL.createObjectURL(data);
      const a = document.createElement("a");
      document.body.appendChild(a);
      a.download = 'texcrop.' + fileType;
      a.href = url;
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
    });
  }

  onResetClicked() {
    this.updateParams();
    this.edit.source = "";
    this.view.image = null;
    location.hash = "";
  }

  private parseQuery(query: string): any {
    if (query == '') {
      return {};
    }
    let list = query.substring(1).split('&');
    const param = {}
    for (const c of list) {
      const [ k, v ] = c.split('=');
      param[k] = v;
    }
    return param;
  }

  private s2b(s: string): boolean {
    return (s === '0') ? false : true;
  }
}
